import { ErrorDialog } from '@/components/dialogs/errorDialog';

export const OwnCloudErrorDialog = ({
  isOpen,
  onClose,
  error,
}: {
  isOpen: boolean;
  onClose: () => void;
  error: Error | null;
}) => {
  return (
    <ErrorDialog
      isOpen={isOpen}
      onClose={onClose}
      title='We couldn’t complete this step'
      description='We ran into an issue while processing this step. Please contact our team with this error for assistance'
      error={error || new Error('Unknown error')}
    />
  );
};
